import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from "../Sidebar";
import Menu from "../Menu";
import Adl from "../Adl";
import Adr from "../Adr";


const Css3BoxSizing = () => {
const syntax_1 = `  <div>`
const syntax_2 = `  div {
   width: 200px;
   height: 200px;
   padding: 20px;
   border: 10px solid black;
  }
`
const syntax_3 = `  .content-box {
   box-sizing: content-box;
  }
  .border-box {
   box-sizing: border-box;
  }
  div {
   width: 200px;
   height: 200px;
   padding: 20px;
   border: 10px solid black;
   background: yellow;
  }
`
const syntax_4 = `  * {
   box-sizing: border-box;
  }
`
  return(
    <>
    <Menu />
    <div className="container-fluid mt-2">
      <div className="row">
        <div className="col-md-3">
          <Sidebar />
        </div>
        <div className="col-md-9 mt-2 p-3 bg-light">
          <h3>CSS3 Box Sizing</h3>
          <p>By default, the padding and border widths add up to the total render width and height of an element.</p> 
          <p>The example below shows a <b>{syntax_1}</b> element whose total width (and height) is <b>260px</b>.</p>
          <pre className='mb-1'>
              <code>{syntax_2}</code>
          </pre>
          <p> The width (and height) of the element below is <b>260px</b>. </p>
          <p> Calculation: <b>200px</b> (width) + <b>20px</b> (padding left) + <b>20px</b> (padding right) + <b>10px</b> (border left) + <b>10px</b> (border right) = <b>260px</b> </p>
          <div className='mb-5' style={{width: "200px", height: "200px", padding: "20px", border: "10px solid black"}}></div>

          <p>Sometimes, this behavior can produce unexpected results.</p>
          <p>What if we need to set a specific <b>width</b> and <b>height</b> for an element? The answer to this is CSS box-sizing.</p>
          <h3>CSS3 Box Sizing Property</h3>
          <p>The box-sizing CSS property sets how the total width and height of an element is calculated.</p>
          <p>Valid Values:</p>
          <ul>
            <li><b>content-box</b> : gives the default box-sizing behavior where the widths of the padding and border are added to the size of an element</li>
            <li><b>border-box</b> : the defined <b>width</b> and <b>height</b> include any border and padding, it causes the content-box to shrink</li>
          </ul>
          <pre className='mb-1'>
            <code>{syntax_3}</code>
          </pre>
          {/* <div className="css3-box-sizing content-box mb-1"> content-box </div>
          <div className="css3-box-sizing border-box mb-5"> border-box </div> */}
          <div className="container mb-5">
            <div className="row">
              <div className="col-md-6">
                <div className="css3-box-sizing content-box"> content-box </div>
              </div>
              <div className="col-md-6">
                <div className="css3-box-sizing border-box"> border-box </div>
              </div>
            </div>
          </div>

          <p>As you may notice, the <b>border-box</b> typically makes sizing elements much better. In fact, most developers prefer their web pages work this way.</p>
          <p>We can apply this to all elements using the <b>*</b> selector which targets all elements.</p>
          <pre className='mb-1'>
            <code>{syntax_4}</code>
          </pre>
          <p style={{boxSizing: "border-box"}}> All elements are now set to <b>box-sizing: border-box</b>. </p>

		  <div className="container mt-5 mb-4 d-flex justify-content-between">
            <Link className="btn btn-primary" to="/css-tutorials/css3-user-interface"><Adl /> Previous</Link>
            <Link className="btn btn-primary" to="/css-tutorials/css3-flexible-boxes">Next <Adr /></Link>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default Css3BoxSizing;